import styled from 'styled-components'

import { FaWindowClose, FaChevronDown } from "react-icons/fa"

import Modal from 'react-modal'

// Campo sobre superficie CLARA (fica direto no fundo bege do SchedulingAdd).
export const Container = styled.div`
  width: 85%;
  height: 50px;
  padding-left: 16px;
  padding-right: 16px;  
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderField};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 14px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;

// MODAL
// DESIGN.md > Componentes: conteudo em `background` (bege), fechar discreto.

export const ModalContainer = styled(Modal)`
  width: 100%;
  height: 100%;   

    @media (min-width: 768px) {   
      padding-left: 35%;
      padding-right: 35%;
    }
`;

export const ModalContent = styled.div`
  width: 100%;
  height: 100%; 
  background-color: ${({ theme }) => theme.colors.surface};   
  overflow-y: auto;
`;

export const CloseButton = styled.button`
  width: 100%;
  border: none;
  display: flex;
  justify-content: start;
  background-color: ${({ theme }) => theme.colors.surface};
`

export const CloseIcon = styled(FaWindowClose).attrs(({ theme }) => ({
  color: theme.colors.surfaceTextSecondary,
  size: 32,
}))`
  margin: 16px;   
`;

export const ArrowDown = styled(FaChevronDown).attrs(({ theme }) => ({
  color: theme.colors.textSecondary,
  size: 18,
}))``;


// CONTENT LIST

// Opcao com fundo TRANSPARENTE: quem cria a figura e o fundo escuro do
// modal, que fica a 11.18:1 da pagina bege. Por estar sobre superficie
// escura, texto e `surfaceText`. Divisor em `surfaceDivider` (2.34:1) e
// nao `surfaceAlt` (1.18:1), que nao le como linha.
export const DataListContainer = styled.button`
  width: 100%;
  height: 50px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surfaceDivider};
  color: ${({ theme }) => theme.colors.surfaceText};
  font-size: 14px;
  transition: color 0.2s, background-color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.accentOnSurface};
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
  }

  &:last-child {
    margin-bottom: 100px; 
}
`
